import type { User } from 'app/types/user';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const isLoggedInAtom = atomWithReset<boolean>(false);
export const userInfoAtom = atomWithReset<User | null>(null);
export const invitedByAtom = atomWithReset<string | undefined | null>(undefined);

export function useResetAuthAtoms() {
  const resetIsLoggedIn = useResetAtom(isLoggedInAtom);
  const resetUserInfo = useResetAtom(userInfoAtom);
  const resetInvitedBy = useResetAtom(invitedByAtom);
  return () => {
    resetIsLoggedIn();
    resetUserInfo();
    resetInvitedBy();
  };
}
